export default __webpack_public_path__ + "locales/pl/ConnectDialog.json?hash=b34e2a663c408418f71581db4fd1ce24";